module.exports = __webpack_public_path__ + "img/yinle1.5d31ba95.png";